import React from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import { EventCard, CtaCard } from '../../../cards';
import styles from '../../../../pages/ProfilePage/profilePage.scss';
import { EventScheduleTypes } from '../../../../utils/eventConstants';
import { getClickAttrs } from '../../../Analytics/gtag';
import { showCompleteRegistration, filterRenderableProfileEvents } from '../../../../utils/events';
import { useStatsig } from '../../../hooks/useStatsig';
import useIsMobile from '../../../hooks/useIsMobile';

const Events = ({ auth, isCurrentUserProfile, type, events, showAll, force, ctaData, search, onHandleTabClick, isProfilePage, entryPoint }) => {
    const history = useHistory();
    const { isMobileWidth } = useIsMobile();
    const { checkGate, featureGates } = useStatsig();
    const isImportedEventPagesEnabled = checkGate(featureGates.IMPORTED_EVENT_PAGES);

    const handleTabClick = () => {
        onHandleTabClick(type);
    };

    const visibleEvents = filterRenderableProfileEvents(events, isImportedEventPagesEnabled);
    const isTwoColumnLayout = !!force?.cardView;

    if ((isCurrentUserProfile && !showAll) || (visibleEvents.length > 0)) {
        return (
            <div>
                <div className="row">
                    {visibleEvents.map((event, i) => {
                        if ((i <= 3 || showAll)) {
                            return (
                                <div
                                    className={`col-12 ${isTwoColumnLayout ? 'col-lg-6' : ''}`}
                                    key={`${type}-event-${event.id ?? i}`}
                                >
                                    <EventCard
                                        event={event}
                                        auth={auth}
                                        force={{ cardView: true }}
                                        unifiedProfileCard
                                        showShareAction={!isTwoColumnLayout}
                                        compactProfileCard={isTwoColumnLayout || isMobileWidth}
                                        showCompleteRegistration={showCompleteRegistration(event, auth.user?.claimedPlayer?.playerId)}
                                        isProfilePage={isProfilePage}
                                        entryPoint={entryPoint}
                                        history={history}
                                        data-testid={event.id ? `profile.events.${type}-event-${event.id}` : `profile.events.${type}-event-${i}`}
                                    />
                                </div>
                            );
                        }
                        return null;
                    })}
                    {isCurrentUserProfile && !showAll && type === EventScheduleTypes.UPCOMING && visibleEvents.length < 2 && ctaData && (
                        <div className={`col-12 col-lg-6`}>
                            <CtaCard
                                data={ctaData.FIND_EVENTS}
                                onCtaClick={() => {
                                    let url = '/search?type=events';
                                    if (search.geocoded) {
                                        url = `/search?type=events&distance=100mi&lat=${search.geocoded.lat}&lng=${search.geocoded.lng}&location=${search.geocoded.location}&locationInputValue=${search.geocoded.location}`;
                                    }
                                    history.push(url);
                                }}
                                className="event-card"
                            />
                        </div>
                    )}
                </div>
                {!showAll && (
                    <div
                        className={`link clickable mt16 ${visibleEvents.length >= 4 ? 'd-block' : 'd-none'}`}
                        onClick={handleTabClick}
                        data-testid={`profile.events.${type}-see-all`}
                    >
                        See All Events
                    </div>
                )}
            </div>
        );
    }

    return (
        isCurrentUserProfile ? (
            <div className={`${styles.placeHolderGrid}`}>
                <div className={`${styles.overlay}`} />
                <div className={`${styles.actionWrapper}`}>
                    <button
                        type="button"
                        className={`btn btn-primary btn-sm text-uppercase`}
                        onClick={() => {
                            const url = '/search?type=events';
                            history.push(url);
                        }}
                        {...getClickAttrs({
                            category: `Player Profile`,
                            context: `Events tab - Find event`,
                            location: 'Player Profile CTA',
                        })}
                    >
                        Find Event
                    </button>
                </div>
            </div>
        ) : (
            <div className="row mt64">
                <div className="col-12">
                    <p className="text-center" data-testid={`profile.events.${type}-empty-state`}>
                        No events have been added yet<br />
                        Check back for events
                    </p>
                </div>
            </div>
        )
    );
};

Events.propTypes = {
    auth: PropTypes.instanceOf(Object).isRequired,
    isProfilePage: PropTypes.bool,
    // Which profile surface these cards sit on, forwarded to imported-event links so the
    // Imported Event Page can report its entryPoint. Null on surfaces that do not track it.
    entryPoint: PropTypes.string,
};

Events.defaultProps = {
    isProfilePage: false,
    entryPoint: null,
};

export default Events;
